import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../_models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
      return this.currentUserSubject.value;
    }
    //handle authentication here when api is ready, all the unauthorized functions, isLoggedIn, etc from fakeBackend
    login(username: string, password: string) {
      var credentials = {username: username, password: password};
      var headers = credentials ? {
        authorization : "Basic " + btoa(credentials.username + ":" + credentials.password)
      } : {};

      return this.http.get<any>(`${environment.apiUrl}/manager/login`, {headers: headers, observe: 'response'})
        .pipe(tap(res => {
          res.body.data.token = res.headers.get('X-Auth-Token');
          localStorage.setItem('currentUser', JSON.stringify(res.body.data));
          this.currentUserSubject.next(res.body.data);
          return res.body;
        }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

}
